export default "__VITE_ASSET__DS0sUyZs__"